// src/components/SidebarItem.js
import React from 'react';

const SidebarItem = ({ Icon, label, active, onClick }) => (
  <div
    className={`flex items-center justify-center md:justify-start space-x-2 p-3 md:p-2 rounded cursor-pointer ${
      active ? 'bg-gray-200' : 'hover:bg-gray-100'
    }`}
    onClick={onClick}
  >
    <Icon size={20} />
    <span>{label}</span>
  </div>
);

export default SidebarItem;
